module.exports = __webpack_public_path__ + "img/info-circle-blk.9f82686f.svg";